<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right" v-if="type == 1">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/serviceIndex' }"
          >客户服务管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/resourceIndex/rServiceDetail'}"
          >客户详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>更新客户信息</el-breadcrumb-item>
      </el-breadcrumb>
      <el-breadcrumb separator-class="el-icon-arrow-right" v-else>
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/allocationIndex' }"
          >客户资源分配管理</el-breadcrumb-item
        >
        <el-breadcrumb-item
          :to="{ path: '/resourceIndex/rAllocationDetail'  }"
          >客户详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>更新客户信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>客户信息更新管理</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p><span class="mark">*</span>客户姓名</p>
            <div class="input_box">
              <el-input
                v-model="formData.info_truename"
                placeholder="输入客户姓名"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>企业名称</p>
            <!-- <div class="input_box">
              <el-input
                v-model="formData.other_company"
                placeholder="输入企业名称"
              ></el-input>
            </div> -->
            <div class="select_box">
              <el-select
                v-model="formData.other_company"
                placeholder="输入企业名称"
                @visible-change="getCustomQyList"
                :disabled="true"
              >
                <el-option
                  v-for="item in customerQy"
                  :key="item.id"
                  :label="item.bodyname"
                  :value="item.bodyname"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>职务</p>
            <div class="input_box">
              <el-input
                v-model="formData.other_job"
                placeholder="输入职务"
                :readonly="true"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p><span class="mark">*</span>联系方式</p>
            <div class="input_box">
              <el-input
                v-model="formData.info_mobile"
                placeholder="输入联系方式"
                :readonly="true"
              ></el-input>
            </div>
          </div>
          <div class="block">
            <p>客户标签</p>
            <div class="input_box">
              <el-radio-group v-model="formData.info_tag_id">
                <el-radio
                  border
                  v-for="item in customerOptin"
                  :key="item.id"
                  :label="item.id"
                  >{{ item.labelname }}</el-radio
                >
              </el-radio-group>
            </div>
          </div>

          <div class="block">
            <p>补充分类</p>
            <div class="select_box">
              <el-select
                v-model="formData.other_type"
                placeholder="请选择补充分类"
                @visible-change="getQywxset('classid')"
              >
                <el-option
                  v-for="item in classidOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p>客户属性</p>
            <div class="select_box">
              <el-select
                v-model="formData.other_attr"
                placeholder="请选择客户属性"
                @visible-change="getQywxset('userattr')"
              >
                <el-option
                  v-for="item in userattrOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p>联系优先度</p>
            <div class="select_box">
              <el-select
                v-model="formData.other_yxd"
                placeholder="请选择联系优先度"
                @visible-change="getQywxset('contactsort')"
              >
                <el-option
                  v-for="item in contactsortOption"
                  :key="item.id"
                  :label="item.evalue"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="block">
            <p>所在地区</p>
            <div class="select_box">
              <el-select
                v-model="formData.other_province"
                placeholder="选择省/直辖市"
                @visible-change="getProvince"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.other_city"
                placeholder="选择城市"
                @visible-change="getCity"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.cityid"
                  :label="item.cityname"
                  :value="item.cityid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="formData.other_area"
                placeholder="选择所在区域"
                @visible-change="getArea"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.addrid"
                  :label="item.addrname"
                  :value="item.addrid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.other_address"
                placeholder="请填写详细地址，50个字符内"
                type="textarea"
              ></el-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="query">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>
<script>
import {
  getProvince,
  getCity,
  getArea,
  getQywxset,
  getCustomerDetail,
  editCustomer,
  getCustomerLabel,
} from "../../api/api";
import { getCustomQyList } from "../../api/company";
export default {
  name: "updateCustomer",
  data() {
    return {
      loading: false,
      qyguid: "",
      id: "",
      type: "",
      formData: {
        appid: "",
        guid: "",
        ext_name: '',  // 客户昵称
        info_remark: "",  // 企业员工姓名
        info_truename: '',  // 客户真实姓名
        other_company: "",
        other_job: "",
        info_remark_mobiles: "",
        info_mobile: '',
        info_tag_id: "",
        other_type: "",
        other_attr: "",
        other_yxd: "",
        other_province: "",
        other_city: "",
        other_area: "",
        other_address: "",

        other_age: 0,
        score: 0,
      },

      classidOption: [], // 补充分类
      userattrOption: [], // 客户属性
      contactsortOption: [], // 联系优先度
      customerOptin: [], // 客户标签
      customerQy: [], // 企业

      provinceList: [],
      provinceTxtL: "",
      cityList: [],
      areaList: [],
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.type = this.$route.params.type;
    this.qyguid = this.$store.state.USERINFO.qy.qyguid;
    this.getCustomerDetail();
    this.getCustomerLabel();
  },
  methods: {
    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        this.formData.appid = res.appid;
        this.formData.guid = res.guid;
        this.formData.info_remark = res.info_remark;  // 企业员工姓名
        this.formData.ext_name = res.ext_name;  // 客户昵称
        this.formData.info_truename = res.info_truename ? res.info_truename : res.ext_name;  // 客户真实姓名
        this.formData.other_company = res.other_company;
        this.formData.other_job = res.other_job;
        this.formData.info_remark_mobiles = res.info_remark_mobiles;
        this.formData.info_mobile = res.info_mobile;
        this.formData.info_tag_id = res.info_tag_id;
        this.formData.other_type = res.other_type;
        this.formData.other_attr = res.other_attr;
        this.formData.other_yxd = res.other_yxd;
        this.formData.other_province = res.other_province ? parseInt(res.other_province) : '';
        this.formData.other_city = res.other_city ? parseInt(res.other_city) : '';
        this.formData.other_area = res.other_area ? parseInt(res.other_area) : '';
        this.formData.other_address = res.other_address;

        if (res.other_province) {
          this.getProvince(true);
          if (res.other_city) {
            this.getCity(true);
            if (res.other_area) {
              this.getArea(true);
            }
          }
        }

        this.getQywxset("classid");
        this.getQywxset("userattr");
        this.getQywxset("contactsort");
      });
    },
    // 获取客户标签
    getCustomerLabel() {
      let params = {
        pageindex: 1,
        pagesize: 100,
        keyword: "",
      };
      getCustomerLabel(params).then((res) => {
        this.customerOptin = res.list;
      });
    },

    // 获取城市
    getProvince(isClick) {
      getProvince().then((res) => {
        this.provinceList = res;
        if (!isClick) {
          this.formData.other_city = "";
          this.formData.other_area = "";
          this.cityList = [];
          this.areaList = [];
        }
      });
    },
    // 获取城市
    getCity(isClick) {
      getCity(this.formData.other_province).then((res) => {
        this.cityList = res;
        if (!isClick) {
          this.formData.other_area = "";
          this.areaList = [];
        }
      });
    },
    // 获取区域
    getArea() {
      getArea(this.formData.other_city).then((res) => {
        this.areaList = res;
      });
    },

    getQywxset(value) {
      getQywxset(value).then((res) => {
        if (value == "classid") {
          this.classidOption = res;
        } else if (value == "userattr") {
          this.userattrOption = res;
        } else if (value == "contactsort") {
          this.contactsortOption = res;
        }
      });
    },

    getCustomQyList() {
      getCustomQyList({ qyguid: this.qyguid }).then((res) => {
        this.customerQy = res.list;
      });
    },

    query() {
      let { formData } = this;
      if (formData.info_truename == "") {
        this.$message.warning("请输入客户姓名");
        return;
      }
      if (formData.other_company == "") {
        this.$message.warning("请输入企业名称");
        return;
      }
      if (formData.other_job == "") {
        this.$message.warning("请输入职务");
        return;
      }
      if (formData.info_mobile == "") {
        this.$message.warning("请输入联系方式");
        return;
      }
      this.loading = true;
      editCustomer(formData).then((res) => {
        if (res.result) {
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .tip_wrap {
        flex: 1;
        .item {
          margin-bottom: 30px;
          color: #6e6e6e;
          h1 {
            margin-bottom: 8px;
            font-size: 18px;
          }
          p {
            font-size: 16px;
          }
        }
      }
    }
  }
  /deep/.el-input.is-disabled .el-input__inner {
    color: #999; /* 例如，改变标签颜色为灰色 */
  }
}
</style>